
import { IrregularOffer } from '@/store/types';
import {
  Component, Emit, ModelSync, Prop, Vue,
} from 'vue-property-decorator';
import { PropType } from 'vue';
import { values } from 'lodash';
import { IrregularPaymentOffer } from '@/services/generated/client';

@Component({
  methods: { values },
})
export default class IrregularOfferConfirmationDialog extends Vue {
  // PROPS
  @Prop({ type: Object as PropType<IrregularOffer>, required: true })
  readonly irregularOffer!: IrregularOffer;

  // MODEL
  @ModelSync('opened', 'opened:change', { type: Boolean })
  readonly isOpened!: boolean;

  // EMITS
  @Emit('confirm')
  onOrderConfirm() {
    return null;
  }

  // METHODS
  getOrderRepresenting(item: IrregularPaymentOffer): string {
    const claimsGroup = values(this.irregularOffer);

    const itemIndex = claimsGroup.indexOf(item);

    if (itemIndex === 0) {
      if (Number(item.count) === 1) {
        return '1.';
      }
      return `1.–${Number(item.count)}.`;
    }

    if (itemIndex > 0) {
      const lastCount = claimsGroup.reduce((sum, repayment, currentIndex) => (currentIndex > itemIndex ? sum : sum + Number(repayment.count)), 0);
      const firstCount = claimsGroup.reduce((sum, repayment, currentIndex) => (currentIndex >= itemIndex ? sum : sum + Number(repayment.count)), 0);

      if (firstCount + 1 === lastCount) {
        return `${firstCount + 1}.`;
      }
      return `${firstCount + 1}.–${lastCount}.`;
    }

    return '';
  }
}
